import { browserFastApiClient, requireFastApiAccessToken } from "@/core/fastapi";
import {
  extractCriteriaApiService,
  type ExtractCriteriaRequest,
} from "@/generated/fastapi";

export async function extractCriteria(
  accessToken: string | null | undefined,
  request: ExtractCriteriaRequest,
) {
  const response = await extractCriteriaApiService({
    client: browserFastApiClient,
    body: request,
    auth: requireFastApiAccessToken(accessToken),
  });

  if (response.status === 200) {
    return response.data;
  }

  throw new Error(response.data?.message || "Failed to extract criteria");
}
